import { render, staticRenderFns } from "./EmergencyCare.vue?vue&type=template&id=3c275268&scoped=true"
import script from "./EmergencyCare.vue?vue&type=script&lang=js"
export * from "./EmergencyCare.vue?vue&type=script&lang=js"
import style0 from "./EmergencyCare.vue?vue&type=style&index=0&id=3c275268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c275268",
  null
  
)

export default component.exports